import React from 'react';

import { Menu } from 'antd';
import { EditOutlined, UploadOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import messagesProduct from 'i18n/messages/product';
import { useGlobalModal } from 'hooks';

const BulkEditProduct = (props) => {
  const { disabled, selectedProducts, selectedFolders, disabledExport } = props;

  const { openModal, MODAL_NAMES } = useGlobalModal();
  const onClickExportButton = () => {
    openModal(MODAL_NAMES.EXPORT_PROPERTY_MODAL);
  };

  const onClickImportButton = () => {
    openModal(MODAL_NAMES.IMPORT_PROPERTY_MODAL);
  };

  const isDisabledExportButton =
    disabledExport || (!selectedProducts?.length && !selectedFolders?.length);

  return (
    <>
      <Menu.Item
        key='export-selected-product-properties'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <RibbonButton
          size='small'
          className='button-item-dropdown'
          icon={<EditOutlined />}
          label={messagesProduct.exportSelectedProduct}
          onClick={onClickExportButton}
          disabled={isDisabledExportButton}
        />
      </Menu.Item>
      <Menu.Item
        key='import-product-properties'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <RibbonButton
          size='small'
          className='button-item-dropdown'
          icon={<UploadOutlined />}
          label={messagesProduct.importBuildEdit}
          onClick={onClickImportButton}
          disabled={disabled}
        />
      </Menu.Item>
    </>
  );
};

export default BulkEditProduct;
